import { useSelector } from 'react-redux';
import { useHomeSlice } from 'app/pages/Home/slice';
import { selectMustWinView } from 'app/pages/Home/slice/selectors';
import { useDeferredViewTransition } from './useDeferredViewTransition';

export function useMonthlyMustWinViewTransition() {
  const mustWinViewActive = useSelector(selectMustWinView);
  const { actions } = useHomeSlice();

  const { active, displayed } = useDeferredViewTransition(
    mustWinViewActive,
    actions.setMustWinViewTransitioning
  );

  return {
    mustWinViewActive: active,
    displayedMustWinView: displayed
  };
}
